import { Button, Grid, TextField, Typography } from "@mui/material";
import React, { useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import squiggleLogo from "../../assets/images/Squiggle_Logo_White.png";
import backgroundImage from "../../assets/images/login_background_image.png";
import Loader from "../../components/Loader";
import { showSnackbar } from "../../slice/snackbarSlice";
import { verifyOtpAction } from "../../thunks/auth";
import { VALIDATION_MSG } from "../../utils/constant";

const VerifyOtp = () => {
  // hooks
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [formInputs, setFormInputs] = useState({ otp: "", email: "" });
  const [isLoader, setLoader] = useState(false);
  const [isFormInvalid, setIsFormInvalid] = useState(false);

  const handleInputChange = (e) => {
    setFormInputs({ ...formInputs, [e.target.name]: e.target.value });
  };

  const handleVerifyOtp = async () => {
    // proceed to Verify Otp
    setIsFormInvalid(true);
    try {
      setLoader(true);
      const payload = {
        otp: formInputs.otp,
        email: localStorage.getItem("email"),
      };
      const responseData = await dispatch(verifyOtpAction(payload)).unwrap();
      if (responseData) {
        setLoader(false);
        dispatch(
          showSnackbar({
            message: " Your email successfully verified",
            severity: "success",
          })
        );
        navigate("/forgot-password/verify-otp/reset-password", {
          state: {
            ...formInputs,
            // date: futureDate,
            email: responseData.data.email,
          },
        });
      }
    } catch (error) {
      setLoader(false);
      dispatch(
        showSnackbar({
          show: true,
          message: `${error?.message}`,
          severity: "error",
        })
      );
    }
  };

  return (
    <div style={{ margin: "0px" }}>
      {/* Loader Component */}
      {isLoader && <Loader />}
      <Container fluid className="h-100">
        <Row>
          <Col xs={7} className="left-col">
            {/* Content for the left column */}
            <div className="backgroundImageWrapper">
              <div
                className="backgroundImageContainer"
                style={{
                  backgroundImage: `url(${backgroundImage})`,
                }}
              >
                <img
                  style={{ height: "100px" }}
                  src={squiggleLogo}
                  alt="squiggle"
                />
              </div>
            </div>
          </Col>
          <Col xs={5} className="right-col">
            {/* Content for the right column */}
            <div className="content">
              <Grid container spacing={3} style={{ marginTop: 0 }}>
                <Grid item xs={12} sx={{ marginBottom: "1rem" }}>
                  <TextField
                    fullWidth
                    className="inputTextField"
                    placeholder="OTP"
                    variant="standard"
                    size="small"
                    name="otp"
                    error={isFormInvalid && !formInputs?.otp}
                    helperText={
                      isFormInvalid &&
                      !formInputs?.otp &&
                      VALIDATION_MSG.REQUIRED
                    }
                    onChange={(e) => handleInputChange(e)}
                    value={formInputs.otp}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Button
                    fullWidth
                    variant="contained"
                    className="forgotPasswordVerifyOtp"
                    disableElevation
                    onClick={(e) => handleVerifyOtp(e)}
                    style={{
                      backgroundColor: "#00ce3f",
                      borderRadius: "20px",
                      width: "200px",
                    }}
                  >
                    Verify Otp
                  </Button>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", justifyContent: "center" }}
                >
                  <div>
                    <Typography
                      className="forgotPasswordTitle"
                      onClick={() => navigate("/forgot-password")}
                    >
                      ForgotPassword ?
                    </Typography>
                  </div>
                </Grid>
              </Grid>
            </div>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default VerifyOtp;
